import { useAsyncData, useRoute, useRouteParams } from '#imports'
import { computed } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import { transformReviewsResponse } from '~/scopes/reviews/reviews-display/utils/transformReviewsResponse'

export function useSellerReviews() {
  const route = useRoute()
  const { uuid: id } = useRouteParams()
  const locale = useI18nLocale()
  const $httpFetch = useHttpFetch()

  const queryParams = computed(() => {
    return {
      ...route.query,
      order_by: route.query.order_by ?? '-relevance_alt',
      translation_locale: locale,
    }
  })

  return useAsyncData(
    computed(() =>
      getAsyncDataKey('seller-reviews', {
        pathParams: { uuid: id },
        query: queryParams.value,
      }),
    ),
    () =>
      $httpFetch('/reviews/v1/sellers/:uuid/products/reviews', {
        pathParams: { uuid: id },
        query: queryParams.value,
      }),
    {
      transform: (response) => ({
        previousCursor: response.previousCursor,
        nextCursor: response.nextCursor,
        results: transformReviewsResponse(response.results),
      }),
    },
  )
}
